module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "buildings"
    }
  }, [_c('el-row', {
    staticClass: "headLine"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("栏目管理")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.newAdd('new')
      }
    }
  }, [_vm._v("新建")])], 1)], 1), _vm._v(" "), _c('Column', {
    ref: "column"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-4dfbe296"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/column/list/index.vue
// module id = 1484
// module chunks = 1